export const channelEntries = [
  { id: 'ch-1', name: '今日瓜条', desc: '首屏前排围观的热门瓜条', icon: 'ri-fire-line', tag: 'TOP', featured: true },
  { id: 'ch-2', name: '现场直击', desc: '一线吃瓜现场图文实时还原', icon: 'ri-camera-lens-line', tag: 'LIVE', featured: false },
  { id: 'ch-3', name: '实锤时间线', desc: '从爆料到澄清的完整瓜线梳理', icon: 'ri-time-line', tag: '线', featured: false },
  { id: 'ch-4', name: '澄清&辟谣', desc: '反转、声明与多方回应速递', icon: 'ri-shield-check-line', tag: '真', featured: false },
  { id: 'ch-5', name: '周边风向', desc: '话题衍生、物料与新梗汇总', icon: 'ri-vip-diamond-line', tag: '料', featured: false },
];

export const hotTops = [
  { rank: 1, title: '某综艺录制现场突发中断，导演组紧急清场，前排观众拍下全过程', heat: '8.6万围观', tags: ['现场', '录制中断'], hot: true },
  { rank: 2, title: '顶流歌手新歌发布 12 小时播放破亿，MV 彩蛋疑似隔空回应', heat: '7.2万围观', tags: ['新歌', '彩蛋'], hot: true },
  { rank: 3, title: '网传婚变双方深夜同步发声，措辞针锋相对冲上热搜', heat: '6.4万围观', tags: ['反转', '同步发声'], hot: false },
  { rank: 4, title: '老牌主持人被拍私下聚餐，身旁神秘人身份成谜', heat: '5.1万围观', tags: ['偶遇', '身份成谜'], hot: false },
  { rank: 5, title: '电竞战队转会尘埃落定，核心选手三年老将确认离队', heat: '4.8万围观', tags: ['电竞', '转会'], hot: false },
  { rank: 6, title: '剧组回应服化道争议，晒出设计稿与工期说明', heat: '3.9万围观', tags: ['剧组', '回应'], hot: false },
  { rank: 7, title: '新人演员片约不断，背后资源方被扒出关联公司', heat: '3.3万围观', tags: ['新人', '背景'], hot: false },
  { rank: 8, title: '综艺常驻名单曝光，疑似带资进组引发粉丝互撕', heat: '2.7万围观', tags: ['选角', '名单'], hot: false },
  { rank: 9, title: '品牌代言官宣前夜，双方工作室动态被逐帧解读', heat: '2.2万围观', tags: ['代言', '解读'], hot: false },
  { rank: 10, title: '前经纪公司发文疑内涵旧将，评论区火速沦陷', heat: '1.8万围观', tags: ['内涵', '评论区'], hot: false },
];

export const liveFeed = [
  { time: '刚刚', zone: '现场', title: '红毯入口临时改道，前排摄影架起长枪短炮等待嘉宾登场', reads: '2.1k', hot: true },
  { time: '12 分钟前', zone: '快讯', title: '活动方发入场凭证补领公告，疑似黄牛倒卖致核销系统崩了', reads: '5.8k', hot: false },
  { time: '26 分钟前', zone: '澄清', title: '当事人经纪团队回应：网传不实，保留法律追究权利', reads: '9.3k', hot: false },
  { time: '41 分钟前', zone: '现场', title: '后台探班流出发际线近景，造型师疑似被点名背锅', reads: '3.2k', hot: false },
  { time: '1 小时前', zone: '快讯', title: '新综艺招商图流出，拟邀名单惊现两位多年未同台艺人', reads: '6.7k', hot: true },
  { time: '1 小时前', zone: '辟谣', title: '官方下场澄清所谓“内定”截图，系旧图拼贴而成', reads: '4.5k', hot: false },
  { time: '2 小时前', zone: '现场', title: '粉丝应援物堆满通道，组织方加派安保维持排队秩序', reads: '2.9k', hot: false },
];

export const spotlightCases = [
  {
    id: 'sp-1',
    zone: '录制现场',
    date: '9月5日',
    title: '综艺录制舞台突遇设备故障，全组暂停三小时等待抢修',
    brief: '录影棚灯光与音响轮番失灵，节目组现场安抚百名观众。前排目击者称导演一度喊话“先稳住，瓜马上来”。',
    reads: '8.6k',
    imgsrc: 'https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20variety%20show%20studio%20set%20mid-production%20with%20camera%20crane%20and%20control%20desk%2C%20sound%20and%20lighting%20crew%20working%2C%20warm%20coral%20red%20amber%20palette%20on%20soft%20cream%20paper%20background%2C%20clean%20modern%20infographic%20style%2C%20no%20text%2C%20high%20detail&width=900&height=620&seq=sp-1&orientation=landscape',
  },
  {
    id: 'sp-2',
    zone: '红毯现场',
    date: '9月5日',
    title: '颁奖礼红毯临时取消签名区，媒体区前排挤爆护栏',
    brief: '为避免拥堵与踩踏风险，主办方临时改掉签名动线。大批媒体与站姐转场抢机位，现场一度失控三分钟。',
    reads: '5.4k',
    imgsrc: 'https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20red%20carpet%20award%20event%20with%20camera%20flashes%20and%20crowd%20barriers%20in%20foreground%2C%20paparazzi%20silhouettes%20holding%20cameras%2C%20warm%20coral%20and%20amber%20stage%20lighting%20on%20cream%20paper%20background%2C%20clean%20modern%20infographic%20style%2C%20no%20text%2C%20high%20detail&width=900&height=620&seq=sp-2&orientation=landscape',
  },
  {
    id: 'sp-3',
    zone: '粉丝应援',
    date: '9月4日',
    title: '粉丝应援灯牌铺满体育场外围，口号喊到破音',
    brief: '演唱会前夕应援物铺满街区，几位粉丝组排演到深夜。路人表示“路过直接被氛围带进去，瓜都不用吃就很燃”。',
    reads: '4.1k',
    imgsrc: 'https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20stadium%20plaza%20covered%20with%20glowing%20light%20signs%20and%20banners%2C%20cheering%20fan%20silhouettes%20raising%20light%20sticks%2C%20warm%20amber%20orange%20night%20glow%20on%20cream%20paper%20background%2C%20clean%20modern%20infographic%20style%2C%20no%20text%2C%20high%20detail&width=900&height=620&seq=sp-3&orientation=landscape',
  },
];

export const faqItems = [
  {
    q: 'cg51 是个什么平台，主要做什么？',
    a: 'cg51 是一处轻量的吃瓜现场聚合入口，专门把散落在各处的娱乐热点与事件进程串成便于前排围观的时间线与瓜条。你既能看到最新进展，也能顺着链接回到原始出处，自己判断、自己吃。',
  },
  {
    q: '为什么叫“前排围观”？信息可信吗？',
    a: '我们把“在场感”当作第一优先级：每条瓜条尽量标注时间、现场与来源方向，并区分爆料、回应、辟谣三种状态。信源多指向原始账号或现场图文，读者可循链接二次核验，平台不做单方定调。',
  },
  {
    q: '我刷到了一条瓜条，怎么判断是实锤还是猜测？',
    a: '看瓜条上的角标：有“现场/实锤”字样且附带时间线的，说明信息有相对完整的证据链；标“辟谣/澄清”的则多来自官方或当事人声明。两者并存时我们会把前后文都摆出来，方便你从时间线上自行比对。',
  },
  {
    q: '能否投稿或提供身边的一线素材？',
    a: '欢迎把线索发给我们，我们会先做信源初步核验再决定是否收录进现场速递。出于核实需要，请尽量附上时间、地点与可辨识的原始出处，匿名线索也可受理，但不会直接照单全发。',
  },
  {
    q: '这些瓜条会影响当事人或造成侵权吗？',
    a: '我们只做信息搬运与时间线梳理，不在缺乏证据时给任何一方下结论。涉及隐私、未成年或明显恶意造谣的内容会优先标注并谨慎处理，原作者要求撤下的侵权素材我们也会尽快复核处理。',
  },
];